import React from "react";
import { FiFileText, FiPackage } from "react-icons/fi";
import { BsFillPeopleFill } from "react-icons/bs";
import { GrUserWorker } from "react-icons/gr";
import { MdOutlinePayments } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { MdOutlineConstruction } from "react-icons/md";
import { TbBuildingCottage } from "react-icons/tb";
import { CiDeliveryTruck } from "react-icons/ci";
import { IoIosArrowForward } from "react-icons/io";
import { IoPeopleOutline } from "react-icons/io5";

function RequestsSection() {
  const navigate = useNavigate();

  const requestTypes = [
    {
      label: "Service Request",
      icon: <FiFileText />,
      link: "/service-request",
    },
    {
      label: "Bills Payment",
      icon: <MdOutlinePayments />,
      link: "/bills-payment",
    },
    {
      label: "Guests",
      icon: <IoPeopleOutline />,
      link: "/register-guests",
    },
    {
      label: "Gate Pass",
      icon: <CiDeliveryTruck />,
      link: "/gate-pass",
    },
    {
      label: "Permits",
      icon: <MdOutlineConstruction />,
      link: "/work-permits",
    },
    {
      label: "Facilities",
      icon: <TbBuildingCottage />,
      link: "/facility-usage",
    },
    {
      label: "Concerns",
      icon: <GrUserWorker />,
      link: "/concerns",
    },
    {
      label: "Parcels",
      icon: <FiPackage />,
      link: "/parcels",
    },
  ];

  // Group items into rows of 4 for grid layout
  const chunkedRequests = [];
  for (let i = 0; i < requestTypes.length; i += 4) {
    chunkedRequests.push(requestTypes.slice(i, i + 4));
  }

  return (
    <div className="bg-white rounded-xl shadow-sm px-4 py-5 mt-2">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm font-semibold text-[#363062]">Services</h2>
        {/* <button className="text-xs text-[#363062] flex items-center">
          View All <IoIosArrowForward className="ml-1" />
        </button> */}
      </div>

      <div className="grid grid-cols-4 gap-4">
        {requestTypes.map((request, index) => (
          <div
            key={index}
            onClick={() => navigate(`${request.link}`)}
            className="flex flex-col items-center cursor-pointer transition-transform active:scale-95 h-18"
          >
            <div className="text-4xl text-eleghoBlue mb-1">{request.icon}</div>
            <span className="text-[10px] font-medium text-center text-gray-700 mt-1">
              {request.label}
            </span>
          </div>
        ))}
      </div>

      {/* <div className="mt-5 bg-gradient-to-r from-[#363062] to-[#4D4C7D] rounded-xl p-3.5 shadow-sm">
        <div className="flex justify-between items-center">
          <div>
            <h3 className="text-white text-xs font-semibold">
              Need assistance?
            </h3>
            <p className="text-[10px] text-gray-200 mt-0.5">
              Our support team is here to help
            </p>
          </div>
          <button
            className="bg-[#8FCD00] text-white text-xs px-3 py-1.5 rounded-lg shadow-sm font-medium"
            onClick={() => navigate("/support")}
          >
            Contact Us
          </button>
        </div>
      </div> */}
    </div>
  );
}

export default RequestsSection;
